import React from 'react';

export const IconArrowDown = ({ width, height, stroke }) => (
  <svg width={width || 24} height={height || 24} fill="none" viewBox="0 0 24 24">
    <path d="M6 9.25L11.5 14.75L17.25 9" stroke={stroke || '#292929'} />
  </svg>
);
